var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechpackDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6456_152071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6456_152071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20.7885L21.2885 17.5L20.6 16.8115L18.5 18.9115V14.025H17.5V18.9115L15.4 16.8115L14.7115 17.5L18 20.7885ZM14.5 24V23H21.5V24H14.5ZM6.1155 20C5.68083 20 5.30292 19.8394 4.98175 19.5182C4.66058 19.1971 4.5 18.8192 4.5 18.3845V4.6155C4.5 4.18083 4.66058 3.80292 4.98175 3.48175C5.30292 3.16058 5.68083 3 6.1155 3H13L18.5 8.5V11.6405H17.5V9H12.5V4H6.1155C5.9615 4 5.82042 4.06408 5.69225 4.19225C5.56408 4.32042 5.5 4.4615 5.5 4.6155V18.3845C5.5 18.5385 5.56408 18.6796 5.69225 18.8077C5.82042 18.9359 5.9615 19 6.1155 19H12.1155V20H6.1155Z",
    fill: "#111927"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechpackDownloadIcon);
export default __webpack_public_path__ + "static/media/techpack_download_icon.8c0a6afce5d662d8d03f97d260b4f92e.svg";
export { ForwardRef as ReactComponent };